<template>
   
    <div> 
        <div class="crumbs" hidden="true" style="margin-left:10px;">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-calendar"></i> 消息通知
                </el-breadcrumb-item>
                 <el-breadcrumb-item>弹窗通知</el-breadcrumb-item>
            </el-breadcrumb>
        </div> 
        <el-card shadow="hover"  class="searchCard" >
                <span class="label-span">
                    <label class="label">条款名称</label> 
                    <el-input v-model.trim="query.name" placeholder="条款名称" class="handle-input mr10"></el-input>  
                </span>   
                <span class="label-span">
                    <label class="label">条款标题</label> 
                    <el-input v-model.trim="query.title" placeholder="条款标题" class="handle-input mr10"></el-input>  
                </span>   
 
                <el-button type="success" icon="el-icon-search"   class="mr10"   @click="handleSearch">搜索</el-button>
                <el-button type="error" icon="el-icon-refresh"   class="mr15"   @click="refreshSearch">重置</el-button>
                  
                <el-button  type="primary"  icon="el-icon-lx-roundadd"   class=" mr10"  @click="addBind" >添加条款</el-button> 
                <el-button  type="danger" icon="el-icon-lx-delete"    @click="delAll" >批量删除</el-button> 
      
        </el-card>
        <el-card shadow="hover"  class="containCard" >
            <el-table v-loading="loading" element-loading-text="正在初始化数据" :data="tableData" border class="table"  ref="multipleTable" header-cell-class-name="table-header"  @selection-change="handleSelectionChange"  >
                <el-table-column type="selection" width="45" align="center"></el-table-column>
                <el-table-column prop="id" width="60" align="center" label="ID"></el-table-column>
                <el-table-column prop="name" min-width="200" align="left" label="条款名称"></el-table-column>  
                <el-table-column prop="title" min-width="200" align="left" label="条款标题"></el-table-column>   
                <el-table-column prop="content" min-width="450" align="left" label="条款内容">
                    <template slot-scope="scope">
                        <p v-html='scope.row.content'  @click="show(scope.row.content)" style="height:100px;font-size:12px;line-height:15px;overflow-y:auto;pointer:cursor"></p>
                    </template>
                </el-table-column> 
                <el-table-column prop="range" width="85" align="center" label="状态"> 
                    <template slot-scope="scope" > 
                         <el-tooltip :content="scope.row.status=='1'?'启用':'禁用'" placement="top">
                            <el-switch @change="handleStatus(scope.$index, scope.row)"
                                v-model="scope.row.status"
                                active-color=""
                                inactive-color=""
                                active-value="1"
                                inactive-value="0">
                            </el-switch>
                        </el-tooltip>
                    </template>   
                </el-table-column>
                <el-table-column prop="createTime" width="165" align="left"  label="创建时间"> </el-table-column>  
                <el-table-column label="操作" min-width="145" align="center" fixed="right">
                    <template slot-scope="scope">  
                        <span class='tableOperBtn' @click="handleEdit(scope.$index, scope.row)" ><i class='el-icon-edit'></i> 编辑</span>
                        <span class='tableOperBtn' @click="handDelete(scope.$index, scope.row)" ><i class='el-icon-delete'></i> 删除</span>
                    </template>
                </el-table-column>  
            </el-table>
            <div class="pagination">
                <el-pagination 
                    background
                    layout="total,  sizes,prev, pager, next,jumper"
                    :page-sizes="[10, 20, 50]"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @size-change="handleSizeChange"
                    @current-change="handlePageChange" 
                ></el-pagination>
            </div>
        </el-card>
        <!-- 新建绑定弹出框 --> 
        <el-dialog name="修改条款" :modal-append-to-body='false' :visible.sync="editVisible"  top="80px" width="700px">
            <el-form ref="form2" :model="form" label-width="80px">
                <el-form-item label="条款名称" >
                    <el-input  type="text" placeholder="不超过20字"  v-model.trim="form2.name"   style="width:580px;" ></el-input>
                    <p style="font-size:12px;color:#999">自定义名称，区分同一标题，不同内容</p>
                </el-form-item>
                <el-form-item label="条款标题"  style="margin-top:-15px;">
                    <el-input  type="text" placeholder="不超过50字"  v-model.trim="form2.title"   style="width:580px;" ></el-input>
                </el-form-item>  
                <el-form-item label="条款内容"  style="margin-top:-10px;"> 
                    <quill-editor ref="myTextEditor" style="width:580px;"  v-model="form2.content" :options="editorOption"></quill-editor>
                </el-form-item> 
            </el-form>
            <span slot="footer" class="dialog-footer"  style="margin-top:-10px;">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="changeForm">确 定</el-button>
            </span>
        </el-dialog> 
        <el-dialog name="添加条款" :modal-append-to-body='false' :visible.sync="addVisible"  top="80px" width="700px">
            <el-form ref="form1" :model="form" label-width="80px"  @submit.native.prevent="saveForm">
               <el-form-item label="条款名称" >
                    <el-input  type="text" placeholder="不超过20字"  v-model.trim="form1.name"   style="width:580px;" ></el-input>
                    <p style="font-size:12px;color:#999">自定义名称，区分同一标题，不同内容</p>
                </el-form-item>
                <el-form-item label="条款标题" style="margin-top:-15px;" >
                    <el-input  type="text" placeholder="不超过50字"  v-model.trim="form1.title"   style="width:580px;" ></el-input>
                </el-form-item>  
                <el-form-item label="条款内容"  style="margin-top:-10px;"> 
                    <quill-editor ref="myTextEditor" style="width:580px;"  v-model="form1.content" :options="editorOption"></quill-editor>
                </el-form-item> 
            </el-form>
            <span slot="footer" class="dialog-footer"  style="margin-top:-10px;">
                <el-button @click="addVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveForm">{{ isSubmitting ? '提交中...' : '提 交' }}</el-button>
            </span>
        </el-dialog> 
        <el-dialog  name="消息内容"   :modal-append-to-body='false'   :visible.sync="imgVisible" width="500px"   height="100%" :before-close="handleClose"  >
            <p v-html='showVal' ></p>
        </el-dialog>
    </div>
</template>

<script>
import {fetchData,saveForm,handDeleteMore,handDelete,handleStatus,changeForm} from '../../api/goodsRead';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import Quill from 'quill'
import { quillEditor } from 'vue-quill-editor';
import { ImageDrop } from 'quill-image-drop-module' // 图片拖动组件引用
import ImageResize from 'quill-image-resize-module' // 图片缩放组件引用
Quill.register('modules/imageDrop', ImageDrop) // 注册
Quill.register('modules/imageResize', ImageResize) // 注册 
const toolbarOptions = [
  ["bold", "italic", "underline", "strike"], // 加粗 斜体 下划线 删除线 -----['bold', 'italic', 'underline', 'strike']
  //["blockquote", "code-block"], // 引用  代码块-----['blockquote', 'code-block']
  [{ list: "ordered" }, { list: "bullet" }], // 有序、无序列表-----[{ list: 'ordered' }, { list: 'bullet' }]
  //[{ 'header': 1 }, { 'header': 2 }],
  //[{ script: "sub" }, { script: "super" }], // 上标/下标-----[{ script: 'sub' }, { script: 'super' }]
  //[{ indent: "-1" }, { indent: "+1" }],
  //[{ size: ['small', false, 'large', 'huge']}], // 配置字号
  [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题-----[{ header: [1, 2, 3, 4, 5, 6, false] }]
  [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色-----[{ color: [] }, { background: [] }]
  //[{ font: []}], //显示字体选择
  [{ align: [] }], // 对齐方式-----
 // ["clean"], // 清除文本格式-----
  ['link', 'image'],// ['link', 'image', 'video'], // 链接、图片、视频-----
]; 
export default {

    data() {
        return {  
            isSubmitting: false, // 是否正在提交
            content: '',
            editorOption: {
                placeholder: '不超过400个字',
                // 主题
                theme: "snow",
                modules: {
                    imageDrop: true,      //图片拖拽
                    imageResize: {          //放大缩小
                    displayStyles: {
                        backgroundColor: "black",
                        border: "none",
                        color: "white"
                        },
                        modules: ["Resize", "DisplaySize", "Toolbar"]
                    }, 
                    toolbar: toolbarOptions,
                },
            },
            Ishow:'el-icon-caret-bottom',
            closeSearch:'',
            Timeout:'', 
            loading:false,  
            showVal:'',
            imgVisible:false,
            query: { 
                pageIndex: 1,
                pageSize: 10, 
            },
            tableData: [],
            multipleSelection: [],
            delList: [], 
            addVisible:false,
            editVisible:false,
            pageTotal: 0,
            form: {  
                ids:'',
                names:'',
            },
            form1: { 
            },
            form2: {  
            },
            idx: -1,
            id: -1
        };
    },
    created() {
         
    },
    components: {
        quillEditor
    },
    //页面加载方法
    mounted: function () { 
        this.getData();  
    },

    methods: { 
        show(content){
            this.showVal = content;
            this.imgVisible=true;
        },
        changeI(){  
                if(this.Ishow == 'el-icon-caret-bottom'){ 
                    this.Ishow = 'el-icon-caret-top';
                    this.closeSearch=false;
                }else{
                    this.Ishow='el-icon-caret-bottom'; 
                     this.closeSearch=true;
                }
            },
        handleStatus(index,row){     

             var tips ;
            var content;
            if(row.status=='0'){ 
                row.status='1';
                tips = "禁用";
                content = "确定禁用吗？";
            }else{ 
                row.status = '0';
                tips = "启用";
                content = "确定启用吗？"; 
            }
            // 二次确认删除
            this.$confirm(content, '提示', {
                type: 'warning'
            }).then(() => { 
                if(row.status=='0'){ 
                    row.status='1' 
                }else{ 
                    row.status='0' 
                }
                handleStatus(row).then(res => {
                    if(res.code=='200'){ 
                        this.$message.success(tips+'成功'); 
                        this.getData();
                    }else{ 
                        if(row.status=='0'){ 
                            row.status='1' 
                        }else{ 
                            row.status='0' 
                        }
                        this.$message.error(tips+'失败');
                    } 
                });
            })
            .catch(() => {}); 
        },
         
        handleSearch() {
            this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },

        //重置按钮
        refreshSearch(){ 
            this.$set(this.query, 'name', '');   
            this.$set(this.query, 'title', '');   
            this.getData();
        }, 

       

         //刷新
        refresh(){
            history.go(0); 
        },

        //查询
        getData(){
            // 获取列表数据   
            fetchData(this.query).then(res => {  
                if(res.code=='200'){ 
                    this.tableData = res.data.list;
                    this.pageTotal = res.data.pageTotal || 0;  
                }else{
                    this.$message("暂无数据");
                } 
                
            });
        }, 
        // 多选操作
        handleSelectionChange(val) {
            this.multipleSelection = val; 
        },
        
        handDelete(index,row){
            this.form.id=row.id; 
            this.form.mid = this.mid; 
            // 二次确认删除 
            this.$confirm('确认删除吗？', '提示', {
                type: 'warning'
            }).then(() => {
                handDelete(this.form).then(res => {
                    if(res.code=='200'){ 
                        this.$message.success('删除成功'); 
                        this.$set(this.query, 'pageIndex', 1); 
                        this.getData();
                    }else{
                        this.$message.error("删除失败"); 
                    } 
                });
            })  
        },
        //批量删除
        delAll() {
            const length = this.multipleSelection.length; 
            if(length===0){
                this.$message.error("请勾选要删除的消息");
                return;
            }
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            }).then(() => {
                let ids = ''; 
                this.delList = this.delList.concat(this.multipleSelection);
                for (let i = 0; i < length; i++) {
                    ids += this.multipleSelection[i].id + ','; 
                } 
                this.form.ids = ids.substr(0,ids.length-1);   
                handDeleteMore(this.form).then(res => {
                    if(res.code=='200'){ 
                        this.$message.success(res.message); 
                        this.getData();
                    }else{
                        this.$message.error(res.message); 
                    }
                });
            }) 
        },
        //取消更改等级
        changeFalse(){ 
            //清空多选值
            this.multipleSelection = [];
            //多选框反选
            this.$refs.multipleTable.clearSelection();
        },

        // 发布消息
        addBind() {
            this.addVisible = true;
        },
        //保存新增
        saveForm() {   
            if (this.isSubmitting) return;
            this.isSubmitting = true; // 禁用按钮
            if( !this.form1.name ){
                this.isSubmitting = false;
                this.$message.error("请填写条款名称");
                return;
            } 
            if( this.form1.name.length>500 ){
                this.isSubmitting = false;
                this.$message.error("条款名称不超过500个字");
                return;
            } 
            if( !this.form1.title ){
                this.isSubmitting = false;
                this.$message.error("请填写条款标题");
                return;
            } 
            if( this.form1.title.length>500 ){
                this.isSubmitting = false;
                this.$message.error("条款标题标题不超过500个字");
                return;
            } 
            this.loading = true; 
            this.addVisible = false;
            saveForm(this.form1).then(res => {
                this.loading = false; 
                this.isSubmitting = false;
                if(res.code=='200'){  
                    this.$message.success(res.message); 
                    this.refreshSearch(); 
                }else{
                    this.addVisible = true;
                    this.$message.error(res.message); 
                } 
            });
        },
        handleEdit(index,row){
            this.form2 = row;
            this.editVisible = true;
        },
        //保存修改
        changeForm() {   
            if( !this.form2.name ){
                this.$message.error("请填写条款名称");
                return;
            } 
            if( this.form2.name.length>200 ){
                this.$message.error("条款名称不超过200个字");
                return;
            } 
            if( !this.form2.title ){
                this.$message.error("请填写条款标题");
                return;
            } 
            if( this.form2.title.length>500 ){
                this.$message.error("条款标题标题不超过500个字");
                return;
            } 
            if( !this.form2.content  ){
                this.$message.error("请填写消息内容");
                return;
            } 
            this.editVisible = false; 
            changeForm(this.form2).then(res => { 
                if(res.code=='200'){ 
                    this.$message.success(res.message); 
                    this.getData();
                }else{
                    this.editVisible = true; 
                    this.$message.error(res.message); 
                } 
            });
        },
         
        // 分页导航
        handlePageChange(val) { 
            this.$set(this.query, 'pageIndex', val);
            this.getData(this.query);
        },
        //分页数量更改导航
        handleSizeChange(val){
            this.$set(this.query, 'pageSize', val);
            this.getData(this.query);
        }
    }
};
</script>

<style>
.label{
    background: #eee;
    font-size: 14px;
    height: 32px;
    display: inline-block;
    line-height: 33px;
    width:100px;
    text-align:center;
    color: #555;
  }
  .label-span{
      display: inline-block;
      height: 40px;
  }
  .red{
      color:red;
      font-weight: 700;
  }
  .mr10 {
    margin-right: 10px;
    margin-left:0;
}
.mr15 {
    margin-right: 15px;
    margin-left:0;
}
.el-dialog__body{
    padding:10px;
}
.el-dialog__footer{
    padding:0px 35px 25px;
}
.ql-container{
    min-height:250px; 
  }
.ql-editor{
	height: 250px;
}
.handle-box {
    width:100%;
    margin-bottom: 20px;
    overflow-x:auto;
}

.handle-select {
    width: 120px;
    display: inline-block;
}

.handle-input {
    width: 150px;
    display: inline-block;
} 
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
 
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
</style>
